define((require) => {
    "use strict";

    var ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/productWidget/ProductWidgetPropertiesView.tpl"),
        AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    const EXPAND_PROPERTY = "productActionExpanded";

    /**
     * The collapsible panels for a product widget, i.e. Product Actions and Position.
     *
     * @class ProductWidgetPropertiesView
     * @constructor
     *
     * @cfg {ProductWidgetModel} model The model for the link widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("ProductWidgetPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            actionProperties: ".action-properties",
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender: function() {
            this.__super();
            this.actionProperties.show(new ActionPropertiesView({
                model: this.model,
                showEffects: false,
                onlyShowProductActions: true
            }));

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/productWidget/ProductWidgetPropertiesView.js